import styled from '@emotion/styled'
import { wrap as withStyle } from 'utils/styles'

const width = 50
const countFontSize = 0.35 * width

export default withStyle(
  () => `
    width:${width}px;
    height:${width}px;
    position:relative;
  `
)

export const SvgStyled = styled.svg`
  width: 100%;
`

export const CircleStyled = styled.circle(
  ({ theme }) => `
    stroke:${theme.vehicleBackroundColor};
  `
)

export const CountStyled = styled.span`
  font-size: ${countFontSize}px;
  font-weight: bold;
  position: absolute;
  left: 4px;
  right: 0;
  top: 4px;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border-radius: 50%;
  width: 42px;
  height: 42px;
`
